<template>
  <a-select
    :mode="mode"
    v-model:value="valueState"
    placeholder="Pilih Distributor"
    style="width: 300px"
    show-search
    not-found-content="Tidak ditemukan"
    option-filter-prop="label"
    option-label-prop="label"
    @search="onSearch"
    @select="() => (findText = null)"
    :size="size"
    :disabled="disabled"
    :show-arrow="true"
  >
    <a-select-option v-for="d in data" :key="d.id" :label="d.name">
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="highlight(d.name)"></span>
      <!--eslint-enable-->
    </a-select-option>
  </a-select>
</template>

<script>
import { onMounted, ref } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'

export default {
  props: {
    value: { type: [Array, Number], default: null },
    mode: {
      default: 'multiple',
      type: String,
    },
    size: {
      default: null,
      type: String,
    },
    disabled: [Boolean],
  },
  emits: ['update:value'],
  setup(props) {
    const data = ref([])
    const findText = ref(null)

    const fetchData = q => {
      apiClient.get('/api/filter/distributor-all', { params: q }).then(response => {
        data.value = response.data
      })
    }
    onMounted(() => {
      fetchData()
    })

    const onSearch = value => {
      findText.value = value
      fetchData(value)
    }

    const highlight = value => {
      if (value === undefined || value === null) return
      return value.replace(new RegExp(findText.value, 'gi'), match => {
        return `<span style="background-color: yellow;">${match}</span>`
      })
    }
    return { data, valueState: useVModel(props, 'value'), findText, highlight, onSearch }
  },
}
</script>

<style></style>
